import { BadgeVariant, Button, Flex, StatusBadge, Text, TextVariant } from '@mprolab/uikit'
import { useTranslation } from 'react-i18next'
import * as React from 'react'
import { useTheme } from 'styled-components'
import { AutostakeProgressStatus, useJoinAutostake } from 'views/Rewards/autoStake.logic'

const AutostakeProgress: React.FC<{ availableStakeAddress: string }> = ({ availableStakeAddress }) => {
  const { t } = useTranslation()
  const { colors } = useTheme()
  const { joinProgress, handleJoinAutostake } = useJoinAutostake(availableStakeAddress)

  const getContent = () => {
    switch (true) {
      case joinProgress === AutostakeProgressStatus.INITIAL:
        return <Button onClick={handleJoinAutostake}>{t('autoStake.joinAutoStake')}</Button>
      case joinProgress === AutostakeProgressStatus.PROGRESS:
        return <StatusBadge customPadding="16px" title={t('modal.continueInWallet')} variant={BadgeVariant.PENDING} />
      case joinProgress === AutostakeProgressStatus.SUCCESS:
        return (
          <Flex flexDirection="column" gap="16px" justifyContent="center" alignItems="center">
            <StatusBadge customPadding="16px" title={t('autoStake.joined')} variant={BadgeVariant.SUCCESS} />
            <Text variant={TextVariant.BODY_SMALL} color={colors.gray6}>
              {t('autoStake.stakeSuccessInfo')}
            </Text>
          </Flex>
        )
      case joinProgress === AutostakeProgressStatus.ERROR:
        return (
          <StatusBadge customPadding="16px" title={t('autoStake.joinAutostakeError')} variant={BadgeVariant.ERROR} />
        )
      default:
        return <></>
    }
  }

  return <>{getContent()}</>
}

export default AutostakeProgress
